import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodMasterCardLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4134_564)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4134_564)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.2614 8.62451H20.0509V23.3755H28.2614V8.62451Z",
				fill: "#FF5A00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.5975 16C20.5975 13.003 22.0064 10.3431 24.1683 8.62451C22.5772 7.3735 20.5701 6.61743 18.3809 6.61743C13.1946 6.61743 8.99829 10.8138 8.99829 16C8.99829 21.1862 13.1946 25.3826 18.3809 25.3826C20.5701 25.3826 22.5772 24.6265 24.1683 23.3755C22.0033 21.6812 20.5975 18.997 20.5975 16Z",
				fill: "#EB001B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.3383 16C39.3383 21.1862 35.1419 25.3826 29.9557 25.3826C27.7664 25.3826 25.7594 24.6265 24.1683 23.3755C26.3575 21.6538 27.7391 18.997 27.7391 16C27.7391 13.003 26.3302 10.3431 24.1683 8.62451C25.7563 7.3735 27.7634 6.61743 29.9527 6.61743C35.1419 6.61743 39.3383 10.8411 39.3383 16Z",
				fill: "#F79E1B"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4134_564",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .02 }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopOpacity: .08
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4134_564",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodMasterCardLight;
